type QueryValue = string | null | undefined | (string | null)[];

export function firstQueryValue(raw: QueryValue): string | undefined {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value ? String(value) : undefined;
}

export function parseSiteIdQuery(raw: QueryValue): number | undefined {
  const value = firstQueryValue(raw);
  return value ? Number(value) : undefined;
}

export function parseMineQuery(raw: QueryValue): boolean {
  return firstQueryValue(raw) === "1";
}

export function parsePhotoIndexParam(raw: QueryValue): number {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return Math.max(1, Number(value) || 1);
}
